import * as Scrivito from "scrivito";
import couponConfigDialogMenuIcon from "../assets/images/arrow_next.svg";

export default function configureMenu() {
  Scrivito.extendMenu((menu) => {
    const enabledForAdmins = () => {
      const groupName = "Chief Editors";
      const editor = Scrivito.currentEditor();
      const teamNames = editor.teams().map((item) => item.name());
      return teamNames.indexOf(groupName) !== -1;
    };

    menu.remove("system.createPage");
    menu.remove("system.openUserGuide");
    menu.remove("system.enableTour");

    menu.insert({
      id: "localsConfiguration",
      title: "Edit locals configuration",
      icon: couponConfigDialogMenuIcon,
      onClick: () => Scrivito.openDialog("LocalsDialog"),
      position: { after: "system.openPageDetails" },
      group: "system.details",
      enabled: enabledForAdmins(),
    });

    menu.insert({
      id: "cleanUpObjects",
      title: "Clean up old and not used Objects",
      icon: couponConfigDialogMenuIcon,
      onClick: () => Scrivito.openDialog("CleanUpDialog"),
      position: { after: "selectConfigurationPage" },
      group: "system.details",
      enabled: enabledForAdmins(),
    });
  });
}
